import { zodResolver } from '@hookform/resolvers/zod';
import { MailCheck } from 'lucide-react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router';
import { toast } from 'sonner';
import { z } from 'zod';

import { api, unwrap } from '@/api/client';
import { mensajeDe } from '@/api/errors';
import { recaptchaHeader, recaptchaToken } from '@/auth/recaptcha';

import { AuthLayout, AvisoRecaptcha, Campo } from './AuthLayout';

const schema = z.object({ email: z.string().trim().email('Escribe un correo válido') });
type Form = z.infer<typeof schema>;

export function RecuperarPage() {
  const [enviado, setEnviado] = useState<string | null>(null);
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<Form>({ resolver: zodResolver(schema) });

  const onSubmit = async (form: Form) => {
    try {
      const token = await recaptchaToken('forgot_password');
      const r = await unwrap<{ message: string }>(
        api.POST('/api/v1/auth/password/forgot', { body: form, headers: recaptchaHeader(token) }),
      );
      setEnviado(r.message);
    } catch (err) {
      toast.error(mensajeDe(err));
    }
  };

  return (
    <AuthLayout titulo="¿Olvidaste tu contraseña?">
      {enviado ? (
        <div className="text-center">
          <MailCheck size={40} className="mx-auto text-verde-texto" />
          <p className="mt-3 text-texto-2">{enviado}</p>
          <p className="mt-2 text-sm text-texto-3">
            El enlace vence en 30 minutos y solo funciona una vez.
          </p>
          <Link to="/login" className="btn-cs btn-primario mt-6 w-full">
            Volver a iniciar sesión
          </Link>
        </div>
      ) : (
        <form onSubmit={(e) => void handleSubmit(onSubmit)(e)} className="space-y-4" noValidate>
          <p className="text-sm text-texto-2">
            Escribe el correo con el que te registraste y te enviaremos un enlace para configurar
            una nueva contraseña.
          </p>
          <Campo etiqueta="Correo electrónico" error={errors.email?.message}>
            <input
              type="email"
              className="input-vidrio"
              autoComplete="email"
              {...register('email')}
            />
          </Campo>
          <button type="submit" className="btn-cs btn-primario w-full py-3" disabled={isSubmitting}>
            {isSubmitting ? 'Enviando…' : 'Enviar enlace'}
          </button>
          <p className="text-center text-sm">
            <Link to="/login">Volver a iniciar sesión</Link>
          </p>
          <AvisoRecaptcha />
        </form>
      )}
    </AuthLayout>
  );
}
